import { API_ROUTE_DOCUMENT } from '../../api/api-router';

import moment from 'moment-timezone';
export const getDocumentRoute = (
  documentId: number,
  accountId: number,
): string => {
  const route = API_ROUTE_DOCUMENT.replace(
    ':accountId',
    accountId?.toString() ?? '',
  ).replace(':documentId', documentId?.toString() ?? '');
  return route;
};
export const saveDocumentFile = (data: ArrayBuffer, label: string) => {
  const blob = new Blob([data], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = `${label}.pdf`;
  link.click();
};

export function calculateDateExpiredSubtractMonths(dateExpired: Date): string {
  const newDate = moment(dateExpired).subtract(3, 'months').toDate();
  return moment.tz(newDate, 'UTC').format();
}

export function calculateDateExpiredAddMonths(dateExpired: Date): string {
  const newDate = moment(dateExpired).add(3, 'months').toDate();
  return moment.tz(newDate, 'UTC').format();
}

const PRESERVED_ON_PICK = ['dateExpired', 'documentType'];

export function applyPickedGedDocument(
  host: any,
  doc: any,
  documentType: string,
) {
  const parameters = { ...host.pledge?.parameters };
  const previous = PRESERVED_ON_PICK.reduce(
    (acc, key) => ({ ...acc, [key]: host.form?.get(key)?.value }),
    {},
  );

  host.error = null;
  host.safeUrl = '';
  host.initForm({ ...doc, document: documentType, parameters }, parameters);

  PRESERVED_ON_PICK.forEach(key => {
    const control = host.form?.get(key);
    if (control && !control.value && previous[key]) {
      control.setValue(previous[key]);
    }
  });

  host.form?.updateValueAndValidity();
  host.displayDocument?.()?.subscribe?.();
}

export function resetDocumentForm(host: any, documentType: string) {
  host.error = null;
  host.safeUrl = '';
  host.entity = null;
  host.form?.patchValue({
    id: null,
    label: null,
    dateCreated: null,
    reviewed: null,
    isSigned: null,
    document: documentType,
  });
  host.form?.updateValueAndValidity();
}
